"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StuffCard = void 0;
exports.renderThing = renderThing;
exports.renderThingAsDOM = renderThingAsDOM;
exports.renderThings = renderThings;
var _litHtml = require("lit-html");
var _solidUi = require("solid-ui");
require("./styles/StuffCard.css");
const StuffCard = (profileBasics, context, subject, stuffData) => {
  const {
    stuff
  } = stuffData;
  const dom = context.dom || document;
  return (0, _litHtml.html)`
    <section
      class="stuffCard"
      aria-labelledby="stuff-card-title"
      role="region"
      data-testid="stuff"
    >
      <header>
        <h3 id="stuff-card-title" class="sr-only">Shared Resources</h3>
      </header>
      <div>
        <table class="stuffTable" data-testid="stuffTable">
          <caption class="sr-only">Files and resources shared by ${profileBasics.name}</caption>
          <tbody class="zebra-stripe">
            ${renderThings(stuff, dom)}
          </tbody>
        </table>
      </div>
    </section>
  `;
};
exports.StuffCard = StuffCard;
function renderThingAsDOM(thing, dom) {
  const options = {};
  // widgets.personTR returns a DOM node, so we need to convert it to HTML string
  const row = _solidUi.widgets.personTR(dom, null, thing.instance, options);
  return row;
}
function renderThing(thing, dom) {
  return renderThingAsDOM(thing, dom);
}
function renderThings(things, dom) {
  if (things.length === 0) return (0, _litHtml.html)``;
  return (0, _litHtml.html)`${renderThing(things[0], dom)}${things.length > 1 ? renderThings(things.slice(1), dom) : (0, _litHtml.html)``}`;
}